export default "__VITE_ASSET__F0YW2uDd__"